export default "__VITE_ASSET__DeTNh32l__"